// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tWB52d8zrYn4ON45JNmq{color:var(--content-negative-primary)}.s19Nedxf2mIuaxa_8Zi9{border:none !important}.HwOR1UFq2s5ElJ8btZSR{padding:12px}`, "",{"version":3,"sources":["webpack://./src/widgets/FilterEditor/ui/Widget/WidgetDate/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,qCAAA,CAEF,sBACE,sBAAA,CAGF,sBACE,YAAA","sourcesContent":[".warning {\n  color: var(--content-negative-primary);\n}\n.calendarClassName {\n  border: none !important;\n}\n\n.datePickerWrap {\n  padding: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"warning": `tWB52d8zrYn4ON45JNmq`,
	"calendarClassName": `s19Nedxf2mIuaxa_8Zi9`,
	"datePickerWrap": `HwOR1UFq2s5ElJ8btZSR`
};
export default ___CSS_LOADER_EXPORT___;
